import { City } from "./types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FetchStateType, getFetchStateChange } from "../../models";

interface ICityData {
  all?: City[];
  searchTerm: string;
  displayData?: City[];
  displayedCity?: City;
  fetchState: FetchStateType;
}

const initialState: ICityData = {
  searchTerm: "",
  fetchState: { type: "not-started" },
};

const name = "cities";

const citySlice = createSlice({
  name,
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<City[] | undefined>) => ({
      ...state,
      all: action.payload,
      displayData: filterData(action.payload, state.searchTerm),
    }),
    setSearchTerm: (state, action: PayloadAction<string>) => ({
      ...state,
      searchTerm: action.payload.toLocaleLowerCase(),
      displayData: filterData(state.all, action.payload),
    }),
    setDisplayed: (state, action: PayloadAction<City | undefined>) => ({
      ...state,
      displayedCity: action.payload,
    }),
    setFetchState: (state, action: PayloadAction<FetchStateType>) => ({
      ...state,
      displayedCity:
        action.payload.type === "successful"
          ? undefined
          : state.displayedCity,
      all: action.payload.type === "successful" ? undefined : state.all,
      displayData:
        action.payload.type === "successful" ? undefined : state.displayData,
      fetchState: getFetchStateChange(state.fetchState, action.payload),
    }),
  },
});

const filterData = (data?: City[], searchTerm?: string) =>
  searchTerm === undefined || searchTerm === ""
    ? data
    : data?.filter(
        (e) =>
          (e.cityName &&
            e.cityName
              .toLocaleLowerCase()
              .includes(searchTerm.toLocaleLowerCase().toLocaleLowerCase())) ||
          (e.zipCode &&
            e.zipCode
              .toLocaleLowerCase()
              .includes(searchTerm.toLocaleLowerCase().toLocaleLowerCase()))
      );

export const {
  setData,
  setSearchTerm,
  setDisplayed,
  setFetchState,
} = citySlice.actions;

export default citySlice.reducer;
